<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>正式考级</el-breadcrumb-item>
         <!-- 考级测试 -->
      </el-breadcrumb>
      <el-alert title="温馨提示" type="warning" class="elalert">
        1.请根据自己的身份选择不同的考试类型<br />
        2.游客身份可以测试客观题，不可以测试实践题。<br />
        3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。<br />
      </el-alert>

      <el-steps
        :space="200"
        :active="0"
        finish-status="success"
        class="elsteps"
      >
        <el-step title="报名信息"></el-step>
        <el-step title="理论测试"></el-step>
        <el-step title="实践考试"></el-step>
        <el-step title="考级结果"></el-step>
        <el-step title="查看证书"></el-step>
      </el-steps>

      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="row.user.face" />
            </div>
            <div class="container_left_content_name">
              <span>姓名：</span>{{ row.user.name }}
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                @click="serviceCustomerClickFun()"
                :style="{ color: '#1981ff' }"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>
        <div class="container_center">
          <el-form
            :model="formData"
            ref="ruleForm"
            :rules="rules"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="地区" prop="areas">
                  <el-cascader
                    v-model="formData.areas"
                    :options="areaOptions"
                    :props="{ label: 'title' }"
                    class="inputSizeClass"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="姓名" prop="name">
                  <el-input
                    type="text"
                    placeholder="请输入姓名"
                    v-model="formData.name"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="身份证号" prop="num">
                  <el-input
                    type="text"
                    placeholder="请输入身份证号"
                    v-model="formData.num"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系手机" prop="phone">
                  <el-input
                    type="text"
                    placeholder="请输入手机"
                    v-model="formData.phone"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="申报级别" prop="grade">
                  <el-select
                    v-model="formData.grade"
                    placeholder="请选择"
                    class="inputSizeClass"
                    @change="onGradeChange"
                  >
                    <el-option
                      v-for="item in gradeOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  v-if="courseOptions.length > 0"
                  label="选修课程"
                  prop="extra_course_id"
                >
                  <el-select
                    v-model="formData.extra_course_id"
                    placeholder="请选择"
                    class="inputSizeClass"
                  >
                    <el-option
                      v-for="item in courseOptions"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="上传照片" prop="pics">
                  <PicUploader
                    :fileList="formData.pics"
                    :limit="5"
                    :name="'pics'"
                  ></PicUploader>
                  <span class="el-note">请上传1寸或2寸图片</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="btn_position_class">
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >提交</el-button
                >
                <el-button @click="resetForm('ruleForm')" plain>重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <ElPayDialog
      :show="payDialogShow"
      scene="kaoji"
      :ids="orderIds"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />
    <OrderDetailDialog
      :fieldArr="fieldArr"
      :dialogShow="orderDetailDialogShow"
      @orderDetailDialogConfirm="orderDetailDialogConfirm"
      @orderDetailDialogCancel="orderDetailDialogCancel"
    />
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import ElPayDialog from "@/components/ElPayDialog";
import NewsListItem from "@/components/listItem/NewsListItem";
import { CountDown } from "vant";
import PicUploader from "@/components/picker/PicUploader";
import OrderDetailDialog from "@/components/OrderDetailDialog";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      areaOptions: [],
      payDialogShow: false,
      orderIds: [],
      kaoji_id: 0,
      rules: {
        areas: [{ required: true, message: "请选择地区", trigger: "blur" }],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        num: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        grade: [{ required: true, message: "请选择等级", trigger: "blur" }],
        extra_course_id: [
          { required: true, message: "请选择课程", trigger: "blur" },
        ],
      },
      formData: {
        areas: [],
        extra_course_id: "",
        grade: "",
        pics: [],
        province: "",
      },
      gradeOptions: [
        {
          id: 1,
          name: "一级",
        },
        {
          id: 2,
          name: "二级",
        },
        {
          id: 3,
          name: "三级",
        },
        {
          id: 4,
          name: "四级",
        },
        {
          id: 5,
          name: "五级",
        },
        {
          id: 6,
          name: "六级",
        },
        {
          id: 7,
          name: "七级",
        },
        {
          id: 8,
          name: "八级",
        },
      ],
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
      courseOptions: [],
      orderDetailDialogShow: false,
    };
  },
  components: {
    NewsListItem,
    ElPayDialog,
    PicUploader,
    OrderDetailDialog,
  },
  computed: {
    //处理弹窗内容
    fieldArr() {
      var fieldArr_temp = [];
      var target_obj = {};
      for (let key in this.formData) {
        target_obj = {};
        switch (key) {
          case "province":
            target_obj.name = "地区";
            target_obj.value =
              this.formData["province"] +
              this.formData["city"] +
              this.formData["county"];
            break;
          case "name":
            target_obj.name = "姓名";
            target_obj.value = this.formData["name"];
            break;
          case "num":
            target_obj.name = "身份证号";
            target_obj.value = this.formData["num"];
            break;
          case "phone":
            target_obj.name = "联系手机";
            target_obj.value = this.formData["phone"];
            break;
          case "grade":
            target_obj.name = "申报级别";
            target_obj.value = this.formData["grade"];
            break;
        }
        if (target_obj.name) {
          fieldArr_temp.push(target_obj);
        }
      } //for  结束

      //处理选修课程
      target_obj = {};
      target_obj.name = "选修课程";
      this.courseOptions.some((item) => {
        if (item.id == this.formData.extra_course_id) {
          target_obj.value = item.title;
        }
      });
      if (target_obj.value) {
        fieldArr_temp.push(target_obj);
      }
      return fieldArr_temp;
    },
  },
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id || 0;
    // if (that.formData.id) {
    this.fetch();
    // }
    that.getAreaOptions();
  },
  methods: {
    orderDetailDialogConfirm() {
      this.payDialogShow = true;
    },
    orderDetailDialogCancel() {
      this.orderDetailDialogShow = false;
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (r) => {
        that.areaOptions = r.data;
      });
    },
    getGradeOptions() {
      let that = this;
      that.$api.post(
        "/api/kaoji/extraCourseOptions",
        {
          grade: that.formData.grade,
        },
        (r) => {
          that.courseOptions = r.data;
        }
      );
    },
    onGradeChange() {
      let that = this;
      that.formData.extra_course_id = "";
      that.getGradeOptions();
    },
    fetch() {
      let that = this;
      that.$api.post(
        "/api/kaoji/step2Detail",
        {
          id: that.formData.id,
        },
        (res) => {
          setTimeout(() => {
            if (res.data.area) {
              res.data.areas = [
                res.data.area.substring(0, 2) + "0000",
                res.data.area.substring(0, 4) + "00",
                res.data.area,
              ];
            } else {
              res.data.areas = [];
            }
          }, 500);
          if (that.formData.id) {
            that.formData = res.data;
          }
          that.getGradeOptions();
          that.row = res.data;
        }
      );
    },
    submitForm(formName) {
      const that = this;
      that.formData["area"] = that.formData.areas[2];
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$api.post("/api/kaoji/apply", that.formData, (r) => {
            // that.$message.success("保存成功");
            that.kaoji_id = r.data.id;
            if (r.data._order.status != 2) {
              //未支付需要先支付
              that.orderIds = [r.data._order.id];

              this.formData.province = r.data.province;
              this.formData.city = r.data.city;
              this.formData.county = r.data.county;
              //处理订单事项
              // that.payDialogShow = true;
              this.orderDetailDialogShow = true;
            } else {
              that.$router.push({
                name: "KaojiExame",
                query: {
                  kaoji_id: that.kaoji_id,
                },
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onPayError() {
      let that = this;
      console.log("onPayError 支付失败");
      that.payDialogShow = false;

      that.$toast("支付失败");

      rbLink(
        {
          name: "kaojiApplyList",
        },
        "replace"
      );
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      // that.payDialogShow = false;

      setTimeout(function () {
        that.$router.push({
          name: "KaojiExame",
          query: {
            kaoji_id: that.kaoji_id,
          },
        });
      }, 500);
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;

      setTimeout(function () {
        rbLink(
          {
            name: "kaojiApplyList",
          },
          "replace"
        );
      }, 500);
    },
  },
};
</script>
<style scoped lang="scss">
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1000px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    padding-top: 24px;
    padding: 88px 0 20px 29px;
    box-sizing: border-box;
    .inputSizeClass {
      width: 240px;
      height: 40px;
      border-radius: 4px;
    }
    .btn_position_class {
      text-align: center;
      margin: 42px 0 0 0;
      box-sizing: border-box;
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
        font-size: 14px;
      }
    }
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// KaojiApplyStep2.vue?6604f460